import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Divider, IconButton, Typography } from '@material-ui/core'

import Paper from '@material-ui/core/Paper'
import DragHandleIcon from '@material-ui/icons/DragHandle'
import LockIcon from '@material-ui/icons/Lock'
import Delete from '@material-ui/icons/Delete'

import styles from './SortableItemStyles'
import Widget from '../../../../features/dashboard/widgets/Widget'

export function Item(props) {
  const { widget, onDelete, listeners, activeId, overlay } = props
  const classes = styles()

  const opacity = {
    opacity: activeId && activeId.id === widget.id && !overlay ? 0 : 1,
  }
  // TODO: this needs an accessibility update
  // items need to be drag and droppable via keyboard
  // when dragging and dropping, voiceover needs to make sense by using title instead of using Widget ID
  return (
    <Paper className={classes.card} style={opacity} variant="outlined">
      <div className={classes.rowContainer}>
        <Typography variant="subtitle1">{widget && widget.title}</Typography>
        <div>
          <IconButton
            onClick={() => onDelete(widget.id)}
            aria-label={
              widget.lock
                ? `${widget.title} widget locked`
                : `Delete ${widget.title} widget`
            }
          >
            {widget.lock ? (
              <LockIcon />
            ) : (
              <Delete className={classes.trashCanIcon} />
            )}
          </IconButton>
          <IconButton {...listeners} aria-label={`Reorder ${widget.title}`}>
            <DragHandleIcon />
          </IconButton>
        </div>
      </div>
      <Divider variant="fullWidth" className={classes.divider} />
      <Widget.Spacer />
    </Paper>
  )
}

export default function SortableItem(props) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: props.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <Item {...props} listeners={listeners} />
    </div>
  )
}
